export const sxStyle = {
  pagination: {
    display: 'flex',
    justifyContent: 'flex-end',
    py: 2,
  },
};
